import { isPlatformBrowser } from '@angular/common'
import { inject, Injectable, PLATFORM_ID } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router'

import { UserStore } from 'app/store/user.store'

@Injectable({
  providedIn: 'root'
})
export class AuthVerifiedGuard implements CanActivate {
  userStore = inject(UserStore)
  router = inject(Router)
  isBrowser = isPlatformBrowser(inject(PLATFORM_ID))

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (!this.isBrowser) {
      return true
    }

    if (this.userStore.isLoggedIn() && this.userStore.isVerified()) {
      return true
    }

    const returnUrl = state.url
    localStorage.setItem('returnUrl', returnUrl)

    const target = this.userStore.isLoggedIn() ? '/email-verification' : '/login'

    return this.router.createUrlTree([target], {
      queryParams: { returnUrl }
    })
  }
}
